import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const getGoalComments = (goalId, token) => async (dispatch) => {
  dispatch({ type: "EMPTY_GOAL_COMMENT" });
  dispatch({ type: "FETCH_GOAL_COMMENT_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getGoalComments/${goalId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data.success) {
      dispatch({
        type: "FETCH_GOAL_COMMENT_SUCCESS",
        payload: response.data?.data,
      });
    } else {
      dispatch({
        type: "FETCH_GOAL_COMMENT_FAILURE",
        payload: response?.message,
      });
    }
  } catch (error) {
    dispatch({ type: "FETCH_GOAL_COMMENT_FAILURE", payload: error.message });
  }
};
